import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { RouterModule ,Router, ActivatedRoute, Params } from '@angular/router';
import { SesionService } from '../../../services/sesion.service';
import { UserService } from '../../../services/user.service';
import { GLOBAL_IMAGES } from '../../../services/global.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  token;
  identity;
  nombre:string;
  img:string;
  public url: string;
  constructor(private _userService: UserService, private session: SesionService,private _route: ActivatedRoute, private _router: Router) { }

  ngOnInit(): void {
    let user = this._userService.getIdentity();
    this.url = GLOBAL_IMAGES.url;
    this.nombre = user.name + ' ' + user.last_name;
    this.img = user.img;
  }

  cerrar_sesion(){
    Swal.fire({
      title: '¿Cerrar Sesión?',
      text: "Desea cerrar la sesión",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Cerrar Sesión'
    }).then((result) => {
      if (result.value) {
        localStorage.removeItem('identity');
        localStorage.removeItem('token');
  
        this.identity = null;
        this.token = null;

        this._router.navigate(['login']);
      }
    })
  }




}
